import merge from 'lodash/merge';

import { getTweekRepository } from './getTweekRepository';

export const updateTweekContext = (context: object) =>
  getTweekRepository().updateContext((currentContext) =>
    merge(currentContext, context),
  );
